module.exports = __webpack_public_path__ + "static/img/android.f7d46f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/android.svg
// module id = gibY
// module chunks = 1